import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from '../listings';

export function Homesites(this: ListingsService, listing: Listing, currentValue: boolean): boolean {
  // If no value is set, do not affect the filter.
  if (!this.filteringService.homesites().length) {
    return currentValue;
  }

  // If the listing does not have a value, exclude it from results.
  if (!listing.features) {
    return false;
  }

  // Determine if the listing matches the filter.
  const _values = this.filteringService.homesites().map((v) => v.replace('^', ','));

  if (!listing.features.some((v: string) => _values.includes(v))) {
    return false;
  }

  // If the listing does not match the filter, do not affect the filter.
  return currentValue;
}
